import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useNavigate, Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faDollarSign,
  faEdit,
  faMoneyBill,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

function Residence({ address, id }) {
  const navigate = useNavigate();

  return (
    <Col className="residence-element">
      <Row>
        <Col lg={6}>
          <h5 onClick={() => navigate(`/residence-details/${id}`)}>
            {address}
          </h5>
        </Col>
        <Col lg={6} className="right">
          <Dropdown>
            <Dropdown.Toggle
              id="dropdown-basic"
              style={{ backgroundColor: "#03acbe", borderColor: "#03acbe" }}
            >
              <FontAwesomeIcon icon={faBars} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item as={Link} to={`/edit-residence/${id}`}>
                <FontAwesomeIcon
                  icon={faEdit}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Editar
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/edit-residence/balance/${id}`}>
                <FontAwesomeIcon
                  icon={faMoneyBill}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Balance inicial
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/edit-residence/discount/${id}`}>
                <FontAwesomeIcon
                  icon={faDollarSign}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Descuento
              </Dropdown.Item>
              <Dropdown.Item as={Link} to={`/delete-residence/${id}`}>
                <FontAwesomeIcon
                  icon={faTrash}
                  style={{ color: "#555", marginRight: 5 }}
                />
                Eliminar
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          {/* <Button
            size="sm"
            onClick={() => navigate(`/edit-residence/${id}`)}
            variant="primary"
            style={{ marginRight: 10 }}
          >
            Editar
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/edit-residence/balance/${id}`)}
            variant="info"
            style={{ marginRight: 10 }}
          >
            Balance inicial
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/edit-residence/discount/${id}`)}
            variant="dark"
            style={{ marginRight: 10 }}
          >
            Descuento
          </Button>
          <Button
            size="sm"
            onClick={() => navigate(`/delete-residence/${id}`)}
            variant="danger"
          >
            Eliminar
          </Button> */}
        </Col>
      </Row>
    </Col>
  );
}

export default Residence;
